export interface BlogImageProps {
  src: string;
  srcSet?: string;
  fallback: string;
}

export function getBlogImageProps(url: string | null | undefined): BlogImageProps | null {
  if (!url) return null;
  // Match blog image path e.g. /images/blog/foo.png or /images/blog/foo.webp
  const match = url.match(/^(\/images\/blog\/[^./]+)(\.(webp|png|jpg|jpeg))?$/);
  if (match) {
    const basePath = match[1];
    return {
      src: `${basePath}-800.webp`,
      srcSet: `${basePath}-480.webp 480w, ${basePath}-800.webp 800w, ${basePath}-1200.webp 1200w`,
      fallback: `${basePath}.webp`
    };
  }
  return {
    src: url,
    srcSet: undefined,
    fallback: url
  };
}
